import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import {
  PersonEntry,
  PersonWrapperEntry,
} from "frontend/contentful/schema/semantics";
import { useContentful } from "frontend/hooks/use-contentful";
import { createArticleRelatedPersonProps } from "./article-related-person.props";
import { RelatedPeopleProps } from "design-system/components/blocks/section-intro-text/section-intro-text";
import { isContentType } from "frontend/contentful/lib/is-content-type";
import { SectionIntroTextEntry } from "frontend/contentful/schema/blocks";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";

function applyPersonWrapperOverrides(
  basePerson: PersonEntry,
  wrapper: PersonWrapperEntry,
): PersonEntry {
  const baseFields = basePerson.fields;
  const wrapperFields = wrapper.fields;

  return {
    ...basePerson,
    fields: {
      ...baseFields,
      displayName: wrapperFields.displayName ?? baseFields.displayName,
      image: wrapperFields.image ?? baseFields.image,
      jobTitles:
        wrapperFields.jobTitles && wrapperFields.jobTitles.length > 0
          ? wrapperFields.jobTitles
          : baseFields.jobTitles,
    },
  };
}

export const createRelatedPeopleProps = createContentfulProps<
  SectionIntroTextEntry,
  RelatedPeopleProps
>(({ entry }) => {
  const { getEntries, getEntry } = useContentful();

  const relatedPeople: RelatedPeopleProps = { people: [] };

  relatedPeople.title = entry.fields.peopleHeading ? (
    <RenderContentfulRichText document={entry.fields.peopleHeading} />
  ) : (
    "Related People"
  );

  getEntries(entry.fields.people).forEach((personEntry) => {
    if (isContentType<PersonEntry>("person", personEntry)) {
      const relatedPersonProps = createArticleRelatedPersonProps(personEntry);

      if (relatedPersonProps) {
        relatedPeople.people?.push(relatedPersonProps);
      }
      return;
    }

    if (isContentType<PersonWrapperEntry>("personWrapper", personEntry)) {
      const basePerson = getEntry(personEntry.fields.person);

      if (basePerson && isContentType<PersonEntry>("person", basePerson)) {
        const resolvedPerson = applyPersonWrapperOverrides(
          basePerson,
          personEntry,
        );

        const relatedPersonProps =
          createArticleRelatedPersonProps(resolvedPerson);

        if (relatedPersonProps) {
          relatedPeople.people?.push(relatedPersonProps);
        }
      }
    }
  });

  return relatedPeople;
});
